import { LoadingSpinner } from "@/shared/ui/LoadingSpinner";
import {
  SidebarProvider,
  SidebarInset,
  useSidebar,
} from "@/shared/ui/sidebar";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { Suspense, useMemo } from "react";
import { Outlet } from "react-router-dom";


import { AppSidebar } from "./AppSidebar";

function OutletWithLogging() {
  return <Outlet />;
}

function MobileBurgerMenu() {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="sticky top-0 z-10 border-b bg-white px-4 py-3 md:hidden">
      <button
        type="button"
        onClick={toggleSidebar}
        className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500/20 touch-manipulation active:scale-95"
        aria-label="Open navigation menu"
      >
        <Bars3Icon className="size-6" aria-hidden="true" />
      </button>
    </div>
  );
}

export default function AppShell() {
  // Memoize style to prevent re-renders
  const sidebarStyle = useMemo(
    () =>
      ({
        "--sidebar-width": "16rem",
        "--sidebar-width-icon": "3rem",
        "--mobile-header-height": "57px", // MobileBurgerMenu height (py-3 = 24px + h-9 = 36px + border = 1px ≈ 60px)
      }) as React.CSSProperties,
    []
  );

  return (
    <SidebarProvider defaultOpen={false} style={sidebarStyle}>
      <AppSidebar />
      <SidebarInset>
        {/* Mobile-only burger menu */}
        <MobileBurgerMenu />
        {/* Main content area */}
        <main id="main" className="flex-1 overflow-hidden">
          <div className="px-4 sm:px-6 lg:px-8 py-10">
            <Suspense fallback={<LoadingSpinner />}>
              <OutletWithLogging />
            </Suspense>
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}